import { useEffect, useState } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSatelliteDish, faHourglassHalf, faRotate } from '@fortawesome/free-solid-svg-icons';

// import './statusPanelComponentStyle.css';

function StatusPanel(props) {
    const [deviceData, setDeviceData] = useState(null); // Store fetched data
    const [error, setError] = useState(null); // Store errors, if any

    useEffect(() => {
        const fetchSensorStatusData = async () => {
            const apiKey = props.props.deviceData.apiKey;
            try {
                const response = await axios({
                    url: `${props.props.url}/api/statusultra`,
                    method: "GET",
                    headers: {
                        apiKey: apiKey,
                    },
                });
                if (response.status === 200) {
                    setDeviceData(response.data.sensor); // Directly store the parsed data
                } else {
                    setError("Error: Could not fetch device status, please try again.");
                }
            } catch (err) {
                setError(err.message);
            }
        };
        fetchSensorStatusData();
        setInterval(() => { fetchSensorStatusData() }, 10000); // Every 10 seconds it will fetch the sensors status
    }, []); // Empty dependency array to run only once when the component mounts

    return (
        <section className='flex column flex-nowrap justify-content-cntr bg-color-background color-foreground padding-sm border rounded'>
            {error ? (
                <p className='h1'>{error}</p>
            ) : deviceData ? (
                <>
                    <div className='flex row flex-nowrap justify-content-space-between bg-color-background'>
                        <h1 className='h3'>{props.props.deviceData.hostname}</h1>
                        <FontAwesomeIcon icon={faSatelliteDish} style={{color: "white"}} size='2xl'/>
                    </div>
                    <div className='flex-nogap row flex-nowrap'>
                        <div className='flex-gap-sm column flex-nowrap margin-l-sm'>
                            <h4 className='font-xs'><b>Status:</b></h4>
                            <h4 className='font-xs'><b>Mode:</b></h4>
                            <h4 className='font-xs'><b>Threshold:</b></h4>
                            <h4 className='font-xs'><b>Last Distance:</b></h4>
                        </div>
                        <div className='flex-gap-sm column flex-nowrap margin-l-md'>
                            <span id='statuspanel-isenabled' className='font-xs'>{deviceData.isEnabled ? <>Scanning<FontAwesomeIcon className='font-xs margin-l-sm rotate-icon' icon={faRotate} style={{color: "green"}} /></> : <>Idle<FontAwesomeIcon className='status-icon' icon={faHourglassHalf} style={{color: "orange"}} /></>}</span>
                            <span id='statuspanel-mode' className='font-xs'>{deviceData.mode}</span>
                            <span id='statuspanel-threshold' className='font-xs'>{deviceData.threshold}</span>
                            <span id='statuspanel-lastdistance' className='font-xs'>{Math.floor(deviceData.lastDistance.value)}{deviceData.lastDistance.measurement} {deviceData.lastDistance.timestamp}</span>
                        </div>
                        {/* // <FontAwesomeIcon className='status-icon rotate-icon' icon={faRotate} style={{color: "green"}} /></> : <>Idle<FontAwesomeIcon className='status-icon' icon={faCirclePause} style={{color: "orange"}} /></>} */}
                    </div>
                </>
            ) : (
                <p>Loading...</p>
            )}
        </section>
    );
}

export default StatusPanel;
